import "./index.less"
import "./indexMobile.less"
import {Col, Row} from "antd";
import MoreButton from "../../MoreButton";
import {isMobile} from "react-device-detect";

export default () => {
    return <>
        {!isMobile && <div className={"section"}>
            <div className={"lightning-bg"}>
                <svg width="800" height="483" viewBox="0 0 800 483" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M402.925 66.3119L0.126953 205.52V482.289L245.595 224.466V350.494L799.956 0.414551L359.268 176.69L402.925 66.3119Z"
                        fill="black" fill-opacity="0.02"/>
                </svg>
            </div>

            <Row justify={"center"} style={{overflow: "hidden"}}>
                <Col>
                    <div className={"brandCulture-Title"}>
                        <Row justify={"center"}>
                            <Col>
                                <div className={"titleTag"}>
                                    Brand Culture
                                </div>
                            </Col>
                        </Row>

                        <Row justify={"center"}>
                            <div className={"titleText"}>
                                Source 品牌
                            </div>
                        </Row>
                    </div>
                </Col>
            </Row>

            <div className={"brandCulture-content"}>
                <Row justify={"center"}>
                    <Col>
                        <div className={"card b-image-card"} style={{
                            backgroundImage: `url(/img_1.png)`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat'
                        }}>

                        </div>
                    </Col>

                    <Col>
                        <div className={"card b-desc-card"} style={{marginTop: "-11px", backgroundColor: "#F3F3F3"}}>
                            <div className={"deleteTransform"}>
                                <Row className={"b-desc-title"} justify={"center"}>
                                    <Col className={"card2-Title"}>
                                        如果你崇尚高端街头文化,诚邀你入队Source！
                                    </Col>
                                </Row>

                                <Row className={"b-desc-desc"}>
                                    <Col className={"card2-Title2"}>
                                        Source 不单是一家多品牌服装店
                                    </Col>
                                </Row>

                                <Row className={"b-desc-content1"}>
                                    <Col className={"card2-text"}>
                                        它更是一个时尚指标。source要求一切内容都是保持原创，有型，新颖以及充满无限创意的。source坚持最纯粹的心态来选择，成为标新立异的发源地，并且回归街头，成为时尚一员。
                                        Source是中国一家高端街头时尚品牌概念店。我们只选择全球最出色的品牌。自2006年起，我们始终致力于将最新的国内外街头文化第一时间传达给中国消费者。
                                    </Col>
                                </Row>

                                <Row justify={"center"} style={{marginTop: "24px"}}>
                                    <Col>
                                        <div className={"card2-line"}></div>
                                    </Col>
                                </Row>

                                <Row className={"b-desc-title b-desc-title2"}>
                                    <Col className={"card2-Title2"}>
                                        以全球街头文化的聚集地以音乐和街头艺术为主题
                                    </Col>
                                </Row>

                                <Row className={"b-desc-content1"}>
                                    <Col className={"card2-text"}>
                                        将40多个来自世界各地的街头品牌结合服装、球鞋、饰品以及艺术展现在大家面前，与当下的潮流文化，青年文化相融合，举办青年摄影展和涂鸦艺术展
                                    </Col>
                                </Row>

                                <Row className={"b-desc-button"}>
                                    <Col>
                                        <MoreButton url={"/brandOrigin"}/>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>

                    <Col>
                        <Row>
                            <Col>
                                <div className={"card b-image-card2"} style={{
                                    marginTop: "-11px",
                                    backgroundImage: `url(/img_2.png)`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat'
                                }}>

                                </div>
                            </Col>
                            <Col>
                                <Row>
                                    <Col>
                                        <div className={"card b-image-card3"}
                                             style={{
                                                 marginTop: "-11px",
                                                 backgroundImage: `url(/img_3.png)`,
                                                 backgroundSize: 'cover',
                                                 backgroundPosition: 'center',
                                                 backgroundRepeat: 'no-repeat'
                                             }}>

                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className={"card b-image-card3"}
                                             style={{
                                                 marginTop: "-11px",
                                                 backgroundImage: `url(/img_4.png)`,
                                                 backgroundSize: 'cover',
                                                 backgroundPosition: 'center',
                                                 backgroundRepeat: 'no-repeat'
                                             }}>

                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row style={{marginTop: "-11px"}}>
                            <Col style={{marginLeft: "11px"}}>
                                <Row className={"b-title-padding"}>
                                    <Col className={"titleText"}>
                                        Source 文化构成
                                    </Col>
                                </Row>

                                <Row>
                                    <Col>
                                        <div className={"card-2 b-tagCard card3-text"}>
                                            Multi-Band
                                        </div>
                                    </Col>
                                    <Col style={{marginLeft: "30px", marginTop: "-11px"}}>
                                        <div className={"card-2 b-tagCard card3-text"}>
                                            International
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col style={{marginTop: "11px"}}>
                                        <div className={"card-2 b-tagCard card3-text"}>
                                            Authentic
                                        </div>
                                    </Col>
                                    <Col style={{marginLeft: "30px"}}>
                                        <div className={"card-2 b-tagCard card3-text"}>
                                            Innovative
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </div>}

        {isMobile && <div className={"section fp-auto-height"}>
            <Row justify={"center"} style={{overflow: "hidden"}}>
                <Col>
                    <div className={"brandCulture-Title-mobile"}>
                        <Row justify={"center"}>
                            <Col>
                                <div className={"titleTag-mobile"}>
                                    Brand Culture
                                </div>
                            </Col>
                        </Row>

                        <Row justify={"center"}>
                            <div className={"titleText-mobile"}>
                                Source 品牌
                            </div>
                        </Row>
                    </div>
                </Col>
            </Row>

            <div className={"brandCulture-content-mobile"}>
                <div className={"card"} style={{
                    background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 1) 100%),url(/img_1.png)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                }}>
                    <div className={"desc"}>
                        如果你崇尚高端街头文化，诚邀你入队Source！
                    </div>
                    <div className={"buttonPos-mobile"}>
                        <MoreButton text={"查看更多"}/>
                    </div>
                </div>

                <div className={"container-1"}>
                    <div className={"row1"}>
                        <div className={"card container-1-card"} style={{
                            backgroundImage: `url(/img_3.png)`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat'
                        }}></div>
                        <div className={"card container-1-card"} style={{
                            backgroundImage: `url(/img_4.png)`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat'
                        }}></div>
                    </div>
                    <div className={"row2"}>
                        <div className={"text"}>
                            Source 不单是一家多品牌服装店
                        </div>
                        <div className={"content"}>
                            它更是一个时尚指标。source要求一切内容都是保持原创，有型，新颖以及充满无限创意的。source坚持最纯粹的心态来选择，成为标新立异的发源地，并且回归街头，成为时尚一员。
                            Source是中国一家高端街头时尚品牌概念店。我们只选择全球最出色的品牌。自2006年起，我们始终致力于将最新的国内外街头文化第一时间传达给中国消费者。
                        </div>
                    </div>
                </div>

                <div className={"container-2"}>
                    <div className={"row1"}>
                        <div className={"title"}>
                            以全球街头文化的聚集地以音乐和街头艺术为主题
                        </div>
                        <div className={"desc"}>
                            将40多个来自世界各地的街头品牌结合服装、球鞋、饰品以及艺术展现在大家面前，与当下的潮流文化，青年文化相融合，举办青年摄影展和涂鸦艺术展
                        </div>
                    </div>

                    <div className={"row2"}>
                        <div className={"img-card"} style={{
                            backgroundImage: `url(/img_2.png)`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat'
                        }}>

                        </div>
                    </div>
                </div>

                <div className={"container-3"}>
                    <div className={"title"}>
                        Source 文化构成
                    </div>
                    <div className={"tagContainer"}>
                        <div className={"row"}>
                            <div className={"card-2-mobile b-tagCard-mobile card3-text-mobile"}>
                                Multi-Band
                            </div>
                            <div className={"card-2-mobile b-tagCard-mobile card3-text-mobile"}>
                                International
                            </div>
                        </div>

                        <div className={"row"}>
                            <div className={"card-2-mobile b-tagCard-mobile card3-text-mobile"}>
                                Authentic
                            </div>
                            <div className={"card-2-mobile b-tagCard-mobile card3-text-mobile"}>
                                Innovative
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>}
    </>
}